export default "__VITE_ASSET__C$h8qBXu__"